export const validationMessages = {
  beneficiaryAccountName: {
    required: "Account Name is required",
    invalid: "Only letters, numbers, and spaces are allowed",
  },
  bankName: {
    required: "Bank Name is required",
    invalid: "Only letters, numbers, and spaces are allowed",
  },
  bankCountry: {
    required: "Bank Country is required",
  },
  beneficiaryBankCountry: {
    required: "Bank Country is required",
    invalidForSwift: "Invalid bank country for SWIFT instructions",
  },
  routingNumber: {
    required: "Routing number is required",
    invalid: "Routing number must be exactly 9 digits",
  },
  swiftCode: {
    required: "SWIFT code is required",
  },
  bankAccountNumber: {
    required: "Bank Account Number is required",
    invalid:
      "Account number must be 9–18 digits, 6–10 alphanumeric, or 3 digits, an optional separator, a space, and 1 final digit",
  },
  intermediary: {
    swiftOrAba: { required: "Intermediary ABA / SWIFT is required" },
    bankCountry: { required: "Intermediary Bank Country is required" },
    bankName: { required: "Intermediary Bank Name is required" },
  },
  furtherCredit: {
    line1: { required: "For Further Credit - Line 1 is required" },
  },
  // IR-UI-Revamp_V1: SWIFT field validations
  swiftId: {
    required: "SWIFT ID is required",
    invalid: "SWIFT ID must be up to 11 alphanumeric characters, no spaces or hyphens.",
  },
  iban: {
    required: "IBAN is required",
    invalid: "IBAN must be up to 34 alphanumeric characters, no spaces or hyphens.",
  },
  bankId: {
    required: "Bank ID is required",
    invalid: "Bank ID must be up to 20 digits (numeric only).",
  },
  branchId: {
    invalid: "Branch ID must be up to 10 alphanumeric characters, no spaces or hyphens.",
  },
  paymentMessage: {
    invalid: "Payment Message must be up to 40 alphanumeric characters (spaces allowed, max 5 consecutive).",
  },
  intermediaryRoutingNumber: {
    invalid: "Routing Number must be 9 digits (ABA format).",
  },
} as const;

export type ValidationMessages = typeof validationMessages;
